import React, { useContext, useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom' // Импортируем портал для рендеринга поверх всего
import { dataContext, localestr } from '../utils.js'
import icon from '../icons.svg' 
import TreeView from './TreeView'

function EditFld({ title, Value, typeVal, setVal, disabled = false, style = undefined, id = undefined }) {
    let data = []
    const context = useContext(dataContext)
    data = context.data[typeVal]
    if (typeof data === 'undefined') data = []

    const node = useRef(null);
    const buttonRef = useRef(null); // Реф для вычисления координат инпута
    const [showDlg, setShow] = useState(false);
    const [coords, setCoords] = useState({ top: 0, left: 0, width: 0 }); // Координаты для модалки
    const addTWnd = context.addTWnd

    const new_folder = () => {
        addTWnd('Вибір', typeVal + '_edit', (el) => { setVal(el); setShow(false) }, null, null, true)
    }

    // Вычисляем положение инпута на экране при открытии окна
    const updateCoords = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setCoords({
                top: rect.bottom + window.scrollY, // Строго под инпутом с учетом прокрутки страницы
                left: rect.left + window.scrollX,
                width: Math.max(rect.width, 250) // Ширина не меньше инпута, но минимум 250px для дерева
            });
        }
    };

    useEffect(() => {
        if (typeVal.substring(0, 3) === 'fld') {
            if (context.data[typeVal] === undefined) {
                context.getData('cat' + typeVal.substring(3))
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Закрытие по клику во внешнюю область
    useEffect(() => {
        const listener = (event) => {
            // Если кликнули внутри самого дерева или на кнопку вызова — ничего не делаем
            if (node.current && node.current.contains(event.target)) return;
            if (buttonRef.current && buttonRef.current.contains(event.target)) return;
            setShow(false);
        };
        if (showDlg) {
            document.addEventListener("mousedown", listener);
            window.addEventListener("resize", updateCoords); // Пересчитываем координаты при изменении экрана
        }
        return () => {
            document.removeEventListener("mousedown", listener);
            window.removeEventListener("resize", updateCoords);
        };
    }, [showDlg]);

    const cap = typeVal === 'fldGoods' ? localestr('Товари') : typeVal === 'fldMenuGrp' ? localestr('Категорії меню') : typeVal === 'fldDiscounts' ? localestr('Клієнти/Знижки') : localestr('Контрагенти')
    const elId = 'id' + Math.random()
    let val = (Value || { name: '' }).name || ''

    const handleOpen = (e) => {
        if (!disabled) {
            e.stopPropagation();
            updateCoords();
            setShow(!showDlg);
        }
    };

    return (
        <div style={{ ...style, display: 'inline-flex', position: 'relative', margin: '1px 0', height: '24px' }} onKeyUp={e => { if (e.key === 'F4') { updateCoords(); setShow(!showDlg); } }}>
            {/* Инпут всегда на месте */}
            <input 
                ref={buttonRef}
                title={title} 
                style={{ width: 'calc(100% - 26px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} 
                type='text' 
                value={val} 
                id={elId} 
                readOnly 
                disabled={disabled} 
                onClick={handleOpen}
            />
            <img 
                className='no-print' 
                style={{ marginLeft: '-26px', width: '24px', height: '24px', cursor: 'pointer', opacity: disabled ? 0.5 : 1, zIndex: 2 }} 
                src={icon + '#fld'} 
                alt='' 
                onClick={handleOpen}
            />

            {/* Рендерим выпадающее окно через Портал в корень document.body */}
            {showDlg && createPortal(
                <div 
                    ref={node}
                    className='no-print modal-fld'
                    style={{
                        position: 'absolute',
                        top: `${coords.top}px`,
                        left: `${coords.left}px`,
                        width: `${coords.width}px`,
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        boxShadow: '0px 4px 12px rgba(0,0,0,0.2)',
                        borderRadius: '4px',
                        zIndex: 9999, // Абсолютный приоритет над любыми таблицами
                        padding: '4px',
                        maxHeight: '350px',
                        overflowY: 'auto'
                    }}
                    onClick={(e) => e.stopPropagation()} // Изолируем внутренние клики
                >
                    <TreeView 
                        TreeData={data} 
                        Caption={cap} 
                        currFolder={Value} 
                        hClick={(el) => {
                            setVal(el);
                            setTimeout(() => setShow(false), 0);
                        }} 
                        hDragDrop={() => {}}
                    />
                    <div 
                        style={{ fontWeight: 'bold', cursor: 'pointer', padding: '8px 0 4px 16px', borderTop: '1px solid #eee', marginTop: '4px' }} 
                        onClick={(e) => { e.stopPropagation(); new_folder(); }}
                    >
                        + {localestr('Нова папка')}
                    </div>
                </div>,
                document.body
            )}
        </div>
    )
}

export default EditFld;